<section class="history">
  <router-outlet />
</section>
